import React from 'react';

const Dashboard = () => {
    return (
        <div>
            <h2>Главная форма</h2>

            <div className="card">
                <h3>ETL</h3>

                <div style={{ marginBottom: '2rem' }}>
                    <h4>Очереди</h4>
                    <p>Управление ETL-очередями для обработки данных</p>
                </div>

                <div style={{ marginBottom: '2rem' }}>
                    <h4>Подключения</h4>
                    <p>Настройка подключений к базам данных</p>
                </div>

                <div>
                    <h4>Пользователи</h4>
                    <p>Управление пользователями и правами доступа</p>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;